// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  type TooltipProps,
  type Currency,
  type Currencies
} from '../../../../utilities/types';
import { getMostRecentPartners } from './selectors';
// import { loadPartners, changePage, expandRow, showTooltip } from './reducer';
import CrudTableIndex from '../../../../modules/CrudTable/CrudTableIndex';
import TableHeader from './TableHeader';
import TableRow from '../../../Partners/ReferredPartnersIndex/TableRow';
import { loadReferredPartnersIndex } from '../../../Partners/ReferredPartnersIndex/reducer';
import { getPartnerCurrency } from '../../../../utilities/selectors';
import { setShowId, showTooltip, removeShowId } from '../reducer';
import ReferredPartnersShow from '../../../Partners/ReferredPartnersShow';

export type ReferralDetails = {
  company_name: string,
  email: string,
  id: number,
  total_fees_usd: string,
  total_merchants: number,
  total_processing_vol_usd: string
};
type Props = {
  partnerCurrency: Currency,
  mostRecentPartners: ReferralDetails[],
  loadReferredPartnersIndex: () => void,
  failedLoad: boolean,
  loading: boolean,
  ...$Exact<TooltipProps>,
  removeShowId: () => void,
  showId: number,
  setShowId: number => void,
  currencies: Currencies
};

class Partners extends Component<Props> {
  handleShow = id => {
    this.props.setShowId(id);
  };

  render() {
    return this.props.showId ? (
      <ReferredPartnersShow
        dashboardShowId={this.props.showId}
        dashboardHandleClose={this.props.removeShowId}
      />
    ) : (
      <CrudTableIndex
        TableHeader={
          // $FlowFixMe
          <TableHeader
            activeTooltip={this.props.activeTooltip}
            showTooltip={this.props.showTooltip}
          />
        }
        tableData={this.props.mostRecentPartners}
        loadTableIndexData={this.props.loadReferredPartnersIndex}
        loading={this.props.loading}
        failedLoad={this.props.failedLoad}
        // $FlowFixMe props are passed in by cloneElement
        TableRow={<TableRow />}
        tableBodyOptions={{
          text: 'No Partners Signed Up Yet',
          model: 'Partners',
          img: 'partners',
          currencies: this.props.currencies,
          partnerCurrency: this.props.partnerCurrency,
          handleShow: id => this.handleShow(id)
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  partnerCurrency: getPartnerCurrency(state),
  currencies: state.global.currencies,
  mostRecentPartners: getMostRecentPartners(state),
  loading: state.partners.referredPartners.index.loading,
  failedLoad: state.partners.referredPartners.index.failedLoad,
  activeTooltip: state.dashboard.referrals.activeTooltip,
  showId: state.dashboard.referrals.showId
});

const mapDispatchToProps = {
  showTooltip,
  loadReferredPartnersIndex,
  setShowId,
  removeShowId
};

export default connect(mapStateToProps, mapDispatchToProps)(Partners);
